import React, { useState, useEffect } from 'react';

import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    passwordStrengthContainer: {
      padding: '14px 28px 10px 24px',
      '& .password-expired--row': {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      },
      '& .dot': {
        height: 5,
        width: 5,
        borderRadius: '50%',
        display: 'inline-block',
        marginRight: 8,
      },
      '& .green': {
        backgroundColor: '#00bdbd',
      },
      '& .red': {
        backgroundColor: '#ec663e',
      },
    },
  }),
);

const PasswordStrengthChecker = ({ open, anchorEl, password }) => {
  const classes = useStyles();

  const [minLength8, setMinLength8] = useState(false);
  const [oneUppercase, setOneUppercase] = useState(false);
  const [oneLowerCase, setOneLowerCase] = useState(false);
  const [oneSymbolOrNumber, setOneSymbolOrNumber] = useState(false);

  useEffect(() => {
    setMinLength8(!!password.length && 8 <= password.length);
    setOneUppercase(!!password.match(new RegExp('[A-Z]')));
    setOneLowerCase(!!password.match(new RegExp('[a-z]')));
    setOneSymbolOrNumber(!!password.match(new RegExp("[0-9!#$%&'()*+,-.:;<=>?@[\\]^_`{|}~]")));
  }, [password]);

  return (
    <Popper open={open} anchorEl={anchorEl} placement={'bottom-end'} transition>
      {({ TransitionProps }) => (
        <Fade {...TransitionProps} timeout={350}>
          <Paper>
            <div className={classes.passwordStrengthContainer}>
              <div className="password-expired--row">
                <span className={'dot ' + (minLength8 ? 'green' : 'red')} />8 characters minimum
              </div>
              <div className="password-expired--row">
                <span className={'dot ' + (oneUppercase ? 'green' : 'red')} />
                One uppercase letter
              </div>
              <div className="password-expired--row">
                <span className={'dot ' + (oneLowerCase ? 'green' : 'red')} />
                One lowercase letter
              </div>
              <div className="password-expired--row">
                <span className={'dot ' + (oneSymbolOrNumber ? 'green' : 'red')} />
                One symbol or number
              </div>
            </div>
          </Paper>
        </Fade>
      )}
    </Popper>
  );
};

export default PasswordStrengthChecker;
